const type = {
    missingParams: {
        name: 'MissingParams',
        message: 'Params from page are missing',
    },
};

export default type;
